<template>
  <v-app :style="cssProps">
    <shop-cart></shop-cart>
    <GlobalChatToast />
    <v-app-bar
      v-if="showAppBar"
      elevation="7"
      scroll-target="#scrolling-sheet"
      app
      class="app-bar mx-auto"
      prominent
      height="80px"
      min-height="80px"
      color="#050505">
      <v-row
        v-if="selectedStudio"
        class="mx-auto"
        style="max-width: 1100px"
        :style="this.$route.meta.addAppBarPadding ? 'padding-top: 10px;' : ''"
        no-gutters>
        <v-col cols="9" class="d-flex flex-row">
          <div v-if="showChatBackButton" class="d-flex align-center" style="height: 65px; min-width: 65px">
            <v-btn icon dark large @click="handleChatBackClick">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </div>

          <div v-if="!$route.meta.hideLogo && !showChatBackButton" :style="isShrunk ? 'height: 65px; width: 65px' : ''">
            <v-img
              @click="$router.push('/')"
              :height="isShrunk ? '65px' : '150px'"
              :width="isShrunk ? '65px' : '150px'"
              contain
              position="left center"
              :src="`https://app.wellcomefit.ch/img/logos/studio/WELL-COME-FIT_LOGO_${selectedStudio.code.toUpperCase()}_BLACK.png`"></v-img>
          </div>

          <span
            :class="{ 'mt-2': $route.meta?.navbarTitle && $route.name !== 'Home' && !$route.meta.removeTopMarginNavbarTitle }"
            class="ml-10 white--text align-center d-flex"
            @click="showStudioSelectionNavbarTitle"
            style="font-weight: 1000 !important; font-style: italic; font-size: 1rem"
            v-if="isShrunk"
            >{{ dynamicNavbarTitle }}
          </span>
        </v-col>

        <v-col
          :class="{
            'mt-3': $route.meta?.navbarTitle && $route.name !== 'Home' && $route.name !== 'Workout_v2' && !$route.meta.removeTopMarginNavbarTitle,
          }"
          cols="3"
          class="d-flex align-center justify-end">
          <div v-if="userService.hasRight('ab_create')" class="mr-2" @click="openPanel()">
            <v-icon color="white" x-large>mdi-parking</v-icon>
          </div>
          <div v-else-if="!alibeyStudio" class="Home__greeting-gift mr-2">
            <v-img
              @click="$router.push('/referral')"
              :height="isShrunk ? '45px' : '60px'"
              :width="isShrunk ? '45px' : '60px'"
              src="/img/icons/giftGreen.gif"></v-img>
          </div>
          <div v-if="$route.meta.hideAvatar" style="width: 45px; height: 45px"></div>
          <div v-if="!$route.meta.hideAvatar" class="cursor-pointer d-flex align-center">
            <v-menu
              v-if="!isStudioAccount"
              v-model="notificationBell"
              :close-on-content-click="false"
              offset-y
              left
              nudge-bottom="12"
              nudge-left="10"
              transition="slide-y-transition"
              content-class="notification-menu-glass"
              max-width="380"
              min-width="340">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="d-flex align-center justify-center transition-swing icon-hover-effect"
                  style="height: 45px; width: 45px; border-radius: 50%">
                  <v-badge
                    :value="hasUnreadNotifications"
                    color="#FF5252"
                    dot
                    overlap
                    bordered
                    offset-x="10"
                    offset-y="10"
                    class="notification-badge">
                    <v-avatar :size="isShrunk ? 40 : 45" :color="displayPicture ? 'transparent' : 'grey darken-3'">
                      <img v-if="displayPicture" :src="displayPicture" alt="User Avatar" style="object-fit: cover" />
                      <v-icon v-else dark small>mdi-account</v-icon>
                    </v-avatar>
                  </v-badge>
                </div>
              </template>

              <notification-card
                :notifications="notifications"
                :show-push-cta="showBellPush"
                @mark-all-read="markAllNotificationsAsRead"
                @notification-click="notificationHandler"
                @enable-push="showPushInit = true"
                @close-menu="notificationBell = false" />
            </v-menu>

            <div v-else @click="openEmployeeDialog" class="icon-hover-effect pa-1" style="border-radius: 50%">
              <v-badge :value="hasUnreadNotifications" color="#FF5252" dot overlap bordered offset-x="10" offset-y="10">
                <v-avatar :size="isShrunk ? 40 : 45" :color="displayPicture ? 'transparent' : 'grey darken-3'">
                  <img v-if="displayPicture" :src="displayPicture" alt="User Avatar" />
                  <v-icon v-else dark>mdi-account-circle</v-icon>
                </v-avatar>
              </v-badge>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-sheet id="scrolling-sheet" class="overflow-y-auto" height="100vh" :style="mainSheetStyles">
      <v-container class="fullHeight" :style="mainContainerStyles" :class="mainContainerClasses" fluid>
        <v-card class="app-container-card" :class="appContainerCardClasses" :elevation="appContainerCardElevation">
          <router-view
            @checkPopup="checkPopup"
            @checkVersion="checkVersion"
            @fetchNotifications="fetchNotifications"
            @showPushPopUp="showPushInit = true" />
        </v-card>
      </v-container>
    </v-sheet>

    <bottom-navigation-new v-if="showBottomNav" app></bottom-navigation-new>

    <v-dialog v-model="loadFromStorePopup" max-width="450" persistent>
      <app-store-redirect-card @close="loadFromStorePopup = false"></app-store-redirect-card>
    </v-dialog>

    <v-dialog v-model="consentPopup" style="z-index: 999999 !important" :fullscreen="$vuetify.breakpoint.mobile" max-width="800px" persistent>
      <consent-declaration-card @savedConsent="savedConsent" withSave></consent-declaration-card>
    </v-dialog>

    <v-dialog v-model="nonDisclosureAgreementPopup" :fullscreen="$vuetify.breakpoint.mobile" max-width="800px" persistent>
      <non-disclosure-agreement @savedConsent="savedNonDisclosureAgreement" withSave></non-disclosure-agreement>
    </v-dialog>

    <popup-view ref="popup" :disabled="isPopupDisabled"></popup-view>
    <anamnese-bogen-create @submitted="showGFRecommendations" ref="anamneseBogenRef"></anamnese-bogen-create>
    <studio-selection
      @studio-picked="studioPicked"
      @change-visibility="changeStudioSelectionVisibility"
      :visible="showStudioSelection"></studio-selection>
    <init-push @acceptPush="acceptPush" @declinePush="declinePush" :visible="showPushInit"></init-push>

    <v-snackbar :color="snackbarColor" :timeout="-1" v-model="isOffline">
      <v-icon color="white" class="mr-2">mdi-wifi-off</v-icon>
      <span>{{ snackbarText }}</span>
    </v-snackbar>

    <v-snackbar v-model="updateExists" :timeout="-1" color="primary" right top>
      Ein neues Update ist verfügbar!

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="acceptUpdate"> Update </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="showStudioChangeDialog" persistent max-width="400" content-class="studio-change-dialog">
      <v-card class="glass-card pa-6 text-center d-flex flex-column align-center">
        <div class="sync-icon-wrapper mb-4">
          <v-icon size="40" color="white" class="sync-icon">mdi-sync</v-icon>
          <div class="pulse-ring"></div>
        </div>

        <h3 class="white--text text-h5 font-weight-bold mb-2">Synchronisierung</h3>

        <p class="grey--text text--lighten-2 caption mb-6" style="line-height: 1.6">
          Wir haben festgestellt, dass dein Studio auf einem anderen Gerät geändert wurde zu:
        </p>

        <div class="new-studio-badge mb-8" v-if="detectedRemoteStudio">
          <v-icon left small color="#00993f">mdi-map-marker</v-icon>
          {{ detectedRemoteStudio.name }}
        </div>

        <template v-if="!isSwitchingStudio">
          <v-btn block large color="#00993f" class="white--text elevation-0 rounded-lg mb-3 font-weight-bold" @click="confirmRemoteStudioChange">
            Zu {{ detectedRemoteStudio ? detectedRemoteStudio.name : "neuem Studio" }} wechseln
          </v-btn>

          <v-btn text block small color="white" style="opacity: 0.7" @click="rejectRemoteStudioChange">
            Nein, hier bei {{ selectedStudio ? selectedStudio.name : "diesem Studio" }} bleiben
          </v-btn>
        </template>

        <div v-else class="py-4">
          <v-progress-circular indeterminate color="#00993f" size="32"></v-progress-circular>
          <div class="mt-2 caption white--text font-italic">Studio wird gewechselt...</div>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { store } from "@/store/stores"
import { mapActions, mapState, mapGetters } from "vuex"
import { EventBus } from "./event-bus"
import api from "./api"
import userService from "./services/userService"
import socketService from "@/socketService"
import abortService from "./services/abortService"

// Import Components

import BottomNavigationNew from "./components/BottomNavigationNew"
import AnamneseBogenCreate from "./components/anamneseBogenCreate"
import StudioSelection from "./components/studioSelection/newStudioSelection.vue"
import InitPush from "./components/notification/initPush.vue"
import PopupView from "./components/notification/popupView.vue"
import ConsentDeclarationCard from "./components/consentDeclaration/consentDeclarationCard.vue"
import NonDisclosureAgreement from "./components/nonDisclosureAgreement/nonDisclosureAgreement.vue"
import GlobalChatToast from "./components/GlobalChatToast.vue"
import ShopCart from "./views/shop/shopCart.vue"

// Lazy-load components that are not always visible
const NotificationCard = () => import("./components/notification/NotificationCard.vue")
const AppStoreRedirectCard = () => import("./components/AppStoreRedirectCard.vue")

export default {
  components: {
    ShopCart,
    ConsentDeclarationCard,
    PopupView,
    InitPush,
    BottomNavigationNew,
    AnamneseBogenCreate,
    StudioSelection,
    NonDisclosureAgreement,
    NotificationCard,
    GlobalChatToast,
    AppStoreRedirectCard,
  },

  data() {
    return {
      // Component State
      isAuthenticated: false,
      isShrunk: true,
      scrollPosition: 0,
      abortController: null,
      userService: userService,

      // NEU für den Dialog
      showStudioChangeDialog: false,
      detectedRemoteStudio: null,
      isSwitchingStudio: false,

      // UI State
      isOffline: !navigator.onLine,
      snackbarText: "Internetverbindung unterbrochen",
      snackbarColor: "red",
      loadFromStorePopup: false,
      consentPopup: false,
      nonDisclosureAgreementPopup: false,
      showStudioSelection: false,
      showPushInit: false,
      notificationBell: false,
      cssProps: null,

      // User & Notification Data
      userPicture: null,
      userFirstName: null,
      userConsent: true,
      nonDisclosureAgreement: true,
      notifications: [],

      // Service-worker
      updateExists: false,
      registration: null,

      // Employee Selection
    }
  },

  // #################################################
  // # COMPUTED PROPERTIES                           #
  // #################################################
  computed: {
    ...mapState("navigationStore", ["selectedNavigation"]),
    ...mapState("studioStore", ["selectedStudio", "storeStudios"]),
    ...mapState("navigationStoreNotPersisted", ["navigationItems", "navigationVisible"]),
    ...mapGetters("studioStore", ["getSelectedEmployee"]),
    ...mapState("chatStore", ["activeGroupId"]),
    ...mapGetters("chatStore", ["activeGroupData"]),
    isChatRoute() {
      return this.$route.name === "Chat"
    },

    showChatBackButton() {
      return this.isChatRoute
    },
    dynamicNavbarTitle() {
      // 1. Priorität: Wenn wir im Chat SIND und eine GRUPPE aktiv ist
      if (this.isChatRoute && this.activeGroupData) {
        return this.activeGroupData.name.toUpperCase()
      }

      // 2. Priorität: Deine bestehende Logik für "Home"
      if (this.$route.name === "Home") {
        return this.selectedStudio.name.toUpperCase()
      }

      // 3. Priorität: Der statische Titel aus den Route-Meta-Daten
      if (this.$route.meta?.navbarTitle) {
        return this.$route.meta.navbarTitle.toUpperCase()
      }

      // 4. Fallback
      return this.selectedStudio.name.toUpperCase()
    },
    isStudioAccount() {
      const userEmail = this.userService.getEmail()
      if (!userEmail || !this.storeStudios.length) return false

      if (this.storeStudios.some((studio) => studio.email === userEmail)) {
        if (this.getSelectedEmployee && this.getSelectedEmployee.user === this.userService.getUserId()) {
          this.selectEmployee(null)
        }
        return true
      } else {
        let user = this.userService.getUser()

        this.selectEmployee({
          fullName: user.vorname + " " + user.nachname,
          border: "green",
          user: user._id,
          title: "",
        })
      }
    },
    displayPicture() {
      const selectedEmp = this.getSelectedEmployee
      if (selectedEmp && selectedEmp.picture) {
        return "/img/profilbilder/" + selectedEmp.picture
      }
      if (this.userPicture) {
        return "/img/profilbilder/" + this.userPicture
      }
      return null
    },
    isLocal() {
      return window.location.href.includes("local")
    },
    isPopupDisabled() {
      const isDashboardRoute = this.$route.matched[0]?.name?.includes("dashboard")
      return this.showStudioSelection || isDashboardRoute
    },
    alibeyStudio() {
      return this.selectedStudio && this.selectedStudio.code === "alibey"
    },

    // --- Visibility Computeds ---
    showAppBar() {
      const routeName = this.$route.name
      const matchedName = this.$route.matched[0]?.name
      if (!this.isAuthenticated || this.$route.meta.hideAppBar) return false

      const excludedRoutes = [
        "dashboardHome",
        "courseListExternal",

        "Workout_run",
        "WorkoutSummary",
        "userPayments",
        "userTimestop",
        "userPurchases",
        "campaignTemplateCreator",
        "contractCreatorExtern",
        "contractCreatorExternForm",
        "Landing",
        "courseListWeeklyClean",
        "WorkoutCreate",
        "WorkoutEdit",
        "EinsteinSaunaContest",
        "kfjasdklfjakldsfjklsf",
        "shopMainpage",
        "nutritionMainpage",
      ]

      if (excludedRoutes.includes(routeName) || excludedRoutes.includes(matchedName) || (matchedName && matchedName.includes("AliBey"))) {
        return false
      }
      return true
    },

    showBottomNav() {
      if (this.$route.path.includes("dashboard")) return false
      const excludedRoutes = ["Landing", "WorkoutRun", "kfjasdklfjakldsfjklsf", "courseListWeeklyClean"]
      return this.isAuthenticated && !excludedRoutes.includes(this.$route.name)
    },

    hasUnreadNotifications() {
      if (this.notifications.length === 0) return false
      return this.notifications.some((n) => !n.read)
    },

    showBellPush() {
      if (localStorage.getItem("pushToken")) return false
      // This logic assumes flutter_inappwebview is the primary mechanism for push
      return !!window.flutter_inappwebview
    },

    // --- Dynamic Styling Computeds ---
    mainSheetStyles() {
      const routeName = this.$route.name
      const matchedName = this.$route.matched[0]?.name

      if (
        this.$route.meta.hideAppBar ||
        ["login", "forgot", "campaignTemplateCreator", "courseListWeeklyClean", "kfjasdklfjakldsfjklsf"].includes(routeName) ||
        (matchedName && (matchedName.includes("AliBey") || matchedName === "shopMainpage" || matchedName === "nutritionMainpage"))
      ) {
        return { "max-width": "unset !important" }
      }

      if (this.$route.meta.backgroundColor) {
        return { "background-color": this.$route.meta.backgroundColor }
      }

      if (matchedName === "dashboardHome") {
        return { "background-color": "#1e1e1e" }
      }
      if (
        matchedName &&
        (matchedName.includes("user") ||
          matchedName.includes("Workouts_v2") ||
          matchedName.includes("WorkoutSummary") ||
          matchedName.includes("Workout_run"))
      ) {
        return { "background-color": "rgb(30 30 30)" }
      }
      return { "background-color": "white" }
    },

    mainContainerStyles() {
      const routeName = this.$route.name
      const matchedName = this.$route.matched[0]?.name

      if (
        this.$route.meta.fullWidth ||
        ["login", "forgot", "campaignTemplateCreator", "courseListWeeklyClean", "kfjasdklfjakldsfjklsf", "AliBey", "AliBeyBooking"].includes(
          routeName,
        )
      ) {
        if (!this.$route.meta.hideAppBar) {
          return { "max-width": "unset !important", "margin-top": "80px !important", padding: "0px !important" }
        } else {
          return { "margin-top": "0px", "max-width": "unset !important", padding: "0px !important" }
        }
      }
      if (
        this.$route.meta.hideAppBar ||
        (matchedName && (matchedName === "shopMainpage" || matchedName === "nutritionMainpage" || matchedName.includes("AliBey")))
      ) {
        return { "margin-top": "0px !important" }
      }
      if (matchedName === "dashboardHome" && !this.$vuetify.breakpoint.mobile) {
        return { "background-color": "#1e1e1e", "max-width": "90vw !important" }
      }
      // Default margin is applied via CSS class, so we only handle overrides here
      return {}
    },

    mainContainerClasses() {
      const routeName = this.$route.name
      return {
        forceMarginTop: this.showAppBar,
        "pa-0":
          !this.isAuthenticated ||
          this.$route.meta.hideAppBar ||
          ["Landing", "campaignTemplateCreator", "Chat", "WorkoutRun", "courseListWeeklyClean", "EinsteinSaunaContest", "WorkoutSummary"].includes(
            routeName,
          ) ||
          (this.$route.matched[0] && this.$route.matched[0].name.includes("AliBey")),
        removeMarginTop: !this.showAppBar,
        smallMarginTop: routeName === "Home",
      }
    },

    appContainerCardClasses() {
      const routeName = this.$route.name
      return {
        loginCard: ["login", "forgot", "courseListWeeklyClean"].includes(routeName),
        "rounded-xl elevation-7": !this.$vuetify.breakpoint.mobile && routeName !== "courseListWeeklyClean",
        "mt-0":
          ["campaignTemplateCreator", "login", "courseListWeeklyClean"].includes(routeName) ||
          (this.$route.matched[0] &&
            (this.$route.matched[0].name === "shopMainpage" || this.$route.meta.hideAppBar || this.$route.matched[0].name === "nutritionMainpage")),
        "chat-full-bleed": routeName === "Chat",
      }
    },

    appContainerCardElevation() {
      return this.$vuetify.breakpoint.mobile ? 0 : 0
    },
  },

  // #################################################
  // # LIFECYCLE HOOKS                               #
  // #################################################
  async created() {
    await store.restored
    this.abortController = new abortService()
    this.initialize()
    this.setupEventListeners()
    this.checkLoadFromStorePopup()
    document.addEventListener("swUpdated", this.showUpdateUI, { once: true })
  },

  destroyed() {
    // Clean up to prevent memory leaks
    this.abortController.abort("Component destroyed")
    window.removeEventListener("offline", this.handleOffline)
    window.removeEventListener("online", this.handleOnline)
    window.removeEventListener("initPush", this.initPush)
    EventBus.$off("login", this.login)
    socketService.disconnect()
  },

  // #################################################
  // # WATCHERS                                      #
  // #################################################
  watch: {
    consentPopup(isShowing) {
      if (!isShowing && !this.nonDisclosureAgreement) {
        this.nonDisclosureAgreementPopup = true
      }
      this.toggleNavVisibilityForDialogs(isShowing)
    },

    nonDisclosureAgreementPopup(isShowing) {
      this.toggleNavVisibilityForDialogs(isShowing)
    },

    showPushInit(isShowing) {
      this.setNavigationbarVisibility(!isShowing)
    },

    showStudioSelection(isShowing) {
      this.toggleNavVisibilityForDialogs(isShowing)
    },

    $route: {
      handler(to, from) {
        this.updateThemeColors()
        this.handleNativeHeaderColor(to)
      },
      immediate: true, // Run on initial load
    },
  },

  // #################################################
  // # METHODS                                       #
  // #################################################
  methods: {
    ...mapActions("studioStore", ["setStudios", "setReservationTypes", "setSelectedStudio", "selectEmployee"]),
    ...mapActions("navigationStore", ["setSelectedNavigation"]),
    ...mapActions("navigationStoreNotPersisted", ["setNavigationbarVisibility"]),
    ...mapActions("userStore", ["setUserRights", "setUser", "setUserContract"]),
    ...mapActions("panelStore", ["clearCustomer"]),
    ...mapActions("chatStore", {
      selectChatGroup: "setActiveGroup",
      handleSocketNewMessage: "handleSocketNewMessage",
      handleSocketGroupAdded: "handleSocketGroupAdded",
      handleUserOnline: "handleUserOnline",
      handleUserOffline: "handleUserOffline",
      handleSocketMessageUpdated: "handleSocketMessageUpdated",
      handleSocketMessagesRead: "handleSocketMessagesRead",
      handleUserStartedTyping: "handleUserStartedTyping",
      handleUserStoppedTyping: "handleUserStoppedTyping",
      showGlobalToast: "showGlobalToast",
      handleReactionUpdated: "handleReactionUpdated",
    }),
    // In methods: { ...mapActions(...) }
    ...mapActions("deviceStore", ["resetDeviceList"]), // <--- Hinzufügen, falls noch nicht da

    triggerReview() {
      if (window.flutter_inappwebview) {
        // Ruft das native Popup auf (falls vom OS erlaubt)
        window.flutter_inappwebview.callHandler("requestAppReview", [false])
      }
    },
    openStorePage() {
      if (window.flutter_inappwebview) {
        // Erzwingt das Öffnen der Store-Seite (verlässt die App)
        window.flutter_inappwebview.callHandler("requestAppReview", [true])
      }
    },
    // Ersetze die komplette confirmRemoteStudioChange Methode hiermit:
    async confirmRemoteStudioChange() {
      if (!this.detectedRemoteStudio) return

      this.isSwitchingStudio = true

      try {
        const studio = this.detectedRemoteStudio

        // 1. LocalStorage User Update (GENAU WIE IM PICKER)
        // Das ist wichtig, damit bei einem manuellen Reload später alles stimmt
        let user = JSON.parse(localStorage.getItem("user"))
        if (user?.user) {
          user.user.studio_id = studio.code
          user.user.studio = studio
          localStorage.setItem("user", JSON.stringify(user))
        }

        // 2. API Call (Session Update im Backend)
        await api.pickStudio({ studio_code: studio.code })

        // 3. Vuex Store Update (Reaktivität!)
        // Sobald das läuft, ändern sich Logo und Name in der Navbar SOFORT
        this.setSelectedStudio(studio)

        // 4. Socket Update
        if (socketService.socket && socketService.socket.connected) {
          socketService.socket.emit("change_studio", { newStudioId: studio.code })
        }

        // 5. Reservation Types neu laden (Wichtig für Buchungsregeln)
        if (!this.reservationTypes) {
          try {
            const [reservationAvailability] = await Promise.all([api.reservationTool.fetchReservationAvailability()])
            if (reservationAvailability && reservationAvailability.length > 0) {
              this.setReservationTypes(reservationAvailability)
            }
          } catch (e) {
            console.error(e)
          }
        }

        // 6. Geräte zurücksetzen
        this.resetDeviceList()

        // 7. UI Aufräumen
        this.showStudioChangeDialog = false
        this.isSwitchingStudio = false

        // 8. "Soft Reload" via Router (GENAU WIE IM PICKER EVENT HANDLER)
        // Anstatt die Seite neu zu laden, leiten wir um. Das zwingt die Views,
        // sich neu zu rendern und die Daten für das neue Studio zu holen.

        // Caches leeren (optional, aber gut)
        sessionStorage.removeItem("homeCourseData")
        sessionStorage.removeItem("homeNewsData")

        // Wir nutzen den Redirect-Trick, um die aktuelle Seite neu zu laden,
        // ohne die App komplett neu zu starten.
        this.$router.replace(`/redirect/${this.$route.name}`)

        this.$toast.success(`Willkommen im ${studio.name}!`)
      } catch (e) {
        console.error("Fehler beim Studio-Wechsel:", e)
        this.isSwitchingStudio = false
        this.$toast.error("Wechsel fehlgeschlagen")
      }
    },

    async rejectRemoteStudioChange() {
      // Der User will beim ALTEN Studio bleiben.
      // Das bedeutet, wir müssen dem Backend sagen: "Hey, User ist jetzt doch wieder bei Studio X"
      // Damit beim nächsten Reload nicht wieder die Meldung kommt.

      try {
        if (this.selectedStudio) {
          // Wir aktualisieren den User auf das AKTUELLE Studio zurück
          let user = JSON.parse(localStorage.getItem("user"))
          if (user?.user) {
            user.user.studio_id = this.selectedStudio.code
            localStorage.setItem("user", JSON.stringify(user))
          }

          // Backend Update (nur User Präferenz, nicht Session pickStudio, da wir ja schon da sind)
          // Da es keinen direkten "updateUserStudio" Endpunkt gibt, der nur das speichert ohne Context switch,
          // nutzen wir pickStudio erneut für das aktuelle Studio, um sicherzugehen.
          await api.pickStudio({ studio_code: this.selectedStudio.code })
        }
      } catch (e) {
        console.error(e)
      }
      this.showStudioChangeDialog = false
    },
    openPanel() {
      if (this.isStudioAccount && this.getSelectedEmployee == null) {
        this.$router.push({ name: "selectEmployee" })
      } else {
        this.$router.push("/panel")
      }
    },
    handleChatBackClick() {
      if (this.activeGroupId) {
        this.selectChatGroup(null)
      } else {
        this.$router.push("/")
      }
    },
    showUpdateUI(e) {
      if (this.userService.hasRight("u_search")) {
        this.registration = e.detail
        this.updateExists = true
      }
    },
    openEmployeeDialog() {
      this.$router.push({ name: "selectEmployee" })
    },

    acceptUpdate() {
      // Verstecke den Button sofort, um doppelte Klicks zu vermeiden
      this.updateExists = false

      // Füge einen Event Listener hinzu, der die Seite neu lädt,
      // sobald der neue Service Worker die Kontrolle übernommen hat.
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload()
      })

      // Stelle sicher, dass ein wartender Worker existiert, bevor du die Nachricht sendest
      if (this.registration && this.registration.waiting) {
        this.registration.waiting.postMessage({ type: "SKIP_WAITING" })
      }
    },
    checkLoadFromStorePopup() {
      if (this.isPopupDisabled) return
      // Check for app store redirect only on mobile web
      if (!window.flutter_inappwebview && this.$vuetify.breakpoint.mobile && !this.userService.hasRight("u_search", "tp_create", "g_daycare")) {
        const noRedirectPaths = ["/contract", "/shop", "/olma", "/wheel", "/r/"]
        if (!noRedirectPaths.some((path) => location.href.includes(path))) {
          this.loadFromStorePopup = true
        }
      }
    },
    async loadTACMembership() {
      console.log("Loading TAC membership...")
      try {
        let contract = await api.fetchTACMemberOwnContract()
        if (contract.Result.resultStatusFlag === "SUCCESS" && contract.MemberDetail) {
          delete contract.MemberDetail.Profile.Profile.Profile.Photo

          this.setUserContract(contract.MemberDetail)
        }
      } catch (e) {
        console.error("Failed to load TAC membership:", e)
      }
    },
    showGFRecommendations(userId) {
      if (this.userService.hasRight("ab_create")) this.$router.push("/gfrecommendations/" + userId)
    },
    // --- Initialization ---
    async initialize() {
      try {
        const data = await api.renewToken(this.abortController.signal)
        await this.handleAuthenticationSuccess(data.token)
      } catch (error) {
        //this.handleAuthenticationError(error)

        if (!navigator.onLine || error.message.includes("Network Error")) {
          // Nicht ausloggen, sondern nur den Offline-Status anzeigen.
          this.handleOffline()
          // Optional: Ein Retry-Mechanismus, wenn die Verbindung wiederhergestellt wird.
          window.addEventListener("online", () => this.initialize(), { once: true })
        } else {
          // Nur bei echten Authentifizierungsfehlern ausloggen.
          this.handleAuthenticationError(error)
        }
      }
    },

    setupEventListeners() {
      window.addEventListener("offline", this.handleOffline)
      window.addEventListener("online", this.handleOnline)
      window.addEventListener("initPush", this.initPush)
      window.addEventListener("pushNavigate", (event) => {
        console.log("PUSH NAVIGATION", event)
        const route = event.detail
        if (route) {
          console.log("Navigiere via Push zu:", route)
          // Prüfen ob wir schon eingeloggt sind, sonst vielleicht redirect merken
          if (this.isAuthenticated) {
            this.$router.push(route).catch((err) => {
              // Ignoriere NavigationDuplicated Fehler
              if (err.name !== "NavigationDuplicated") console.error(err)
            })
          }
        }
      })
      EventBus.$on("login", this.login)
    },

    async loadStaticData() {
      try {
        const [studios, teams, reservationAvailability] = await Promise.all([
          api.fetchStudios(),
          api.fetchTeamsForTitle(),
          api.reservationTool.fetchReservationAvailability(),
        ])

        if (Array.isArray(reservationAvailability)) {
          this.setReservationTypes(reservationAvailability)
        }

        if (Array.isArray(studios) && Array.isArray(teams)) {
          /*const allStudios = [...studios, ...teams].map(({ _id, code, name, growth, vacationDays, tacPropertyId, tacResortId }) => ({
            _id,
            code,
            name,
            growth,
            vacationDays,
            tacPropertyId,
            tacResortId,
          }))*/
          const allStudios = [...studios, ...teams]
          this.setStudios(allStudios)
        }

        if (!this.selectedStudio) {
          try {
            let userStudio = await api.getUserStudio()
            if (userStudio?.studio?._id) {
              this.setSelectedStudio(userStudio.studio)
            }
          } catch (e) {}
        }
      } catch (e) {
        console.error("Failed to load studio data:", e)
      }
    },

    setupSocketListeners() {
      socketService.off("new_notification")
      socketService.on("new_notification", (data) => {
        if (data?.notification) {
          this.notifications.unshift(data.notification)
          if (this.$toast) {
            // this.$toast.success(`${data.notification.title}`)
          }
        }
      })

      socketService.off("chat:newMessage") // Wichtig, um Duplikate zu vermeiden
      socketService.on("chat:newMessage", (message) => {
        // 1. Rufe die "Alles-in-einem"-Action auf.
        // Diese Action aktualisiert den Chat, den Badge, den Text UND die Sortierung.
        this.handleSocketNewMessage(message) // 2. --- Dein "Türsteher" für den TOAST (bleibt gleich) ---

        const myUserId = this.$store.state.userStore.user._id
        const activeGroupId = this.$store.state.chatStore.activeGroupId
        const isDisabledOnThisRoute = this.$route.meta.disableChatToasts

        const shouldShowToast = !isDisabledOnThisRoute && message.groupId !== activeGroupId && message.senderId._id !== myUserId

        if (shouldShowToast) {
          this.showGlobalToast(message)
        }
      })
      socketService.off("chat:groupAdded")
      socketService.on("chat:groupAdded", (group) => {
        console.log("Socket: Zu neuer Gruppe hinzugefügt!", group)
        this.handleSocketGroupAdded(group) // Ruft die Vuex-Action auf
      })
      socketService.off("chat:error")
      socketService.on("chat:error", (error) => {
        console.error("Socket-Chat-Fehler:", error.message)
        if (this.$toast) {
          this.$toast.error(`Chat-Fehler: ${error.message}`)
        }
      })
      socketService.off("chat:userStartedTyping")
      socketService.on("chat:userStartedTyping", (payload) => {
        this.handleUserStartedTyping(payload)
      })

      // 9. Lausche, wenn jemand aufhört zu tippen
      socketService.off("chat:userStoppedTyping")
      socketService.on("chat:userStoppedTyping", (payload) => {
        this.handleUserStoppedTyping(payload)
      })
      socketService.off("chat:reactionUpdated")
      socketService.on("chat:reactionUpdated", (payload) => {
        this.handleReactionUpdated(payload)
      })
      socketService.off("chat:userReadMessages")
      socketService.on("chat:userReadMessages", (payload) => {
        this.handleSocketMessagesRead(payload) // Ruft Action auf
      })
      socketService.off("chat:userOnline")
      socketService.on("chat:userOnline", (payload) => {
        this.handleUserOnline(payload) // Ruft Action auf
      }) // 5. Lausche auf Offline-Status

      socketService.off("chat:userOffline")
      socketService.on("chat:userOffline", (payload) => {
        this.handleUserOffline(payload) // Ruft Action auf
      })
      socketService.off("chat:messageUpdated")
      socketService.on("chat:messageUpdated", (message) => {
        this.handleSocketMessageUpdated(message) // Ruft Action auf
      })
    },
    showStudioSelectionNavbarTitle() {
      if (this.$route.name === "Home") {
        this.showStudioSelection = true
      }
    },

    // --- Authentication & User Data ---
    async handleAuthenticationSuccess(token) {
      localStorage.setItem("token", token)
      this.isAuthenticated = true

      const [userData, rightsData] = await Promise.all([api.getUser(), api.getUserRights()])

      // Process User Data
      const user = userData.user

      this.userPicture = user.bild
      this.userFirstName = user.vorname
      this.userConsent = !!user.consent1
      //this.nonDisclosureAgreement = ?? // Add logic if available from user object
      localStorage.setItem("user", JSON.stringify({ user }))
      this.setUser(user)

      // Process Rights
      localStorage.setItem("userRights", JSON.stringify({ userRights: rightsData }))
      this.setUserRights(rightsData)

      // 4. ALLE WEITEREN DATEN LADEN, DIE EINEN LOGIN BENÖTIGEN
      this.loadStaticData() // <--- HIERHER VERSCHOBEN
      this.loadTACMembership() // <--- HIERHER VERSCHOBEN
      this.fetchNotifications() // (war oft schon hier, passt perfekt)
      this.$store.dispatch("chatStore/fetchGroups")
      // Final Setup
      socketService.connect()
      this.setupSocketListeners()

      // Check for required popups
      if (!this.userConsent) {
        this.consentPopup = true
      } else if (!this.nonDisclosureAgreement) {
        this.nonDisclosureAgreementPopup = true
      }
      setTimeout(() => {
        // Wir vergleichen einfach den aktuellen Store (der gerade geladen wurde)
        // mit dem User vom Backend.
        const currentStudio = this.selectedStudio
        const userStudioId = user.studio_id

        if (currentStudio && currentStudio.code && userStudioId && currentStudio.code !== userStudioId) {
          const remoteStudio = this.storeStudios.find((s) => s.code === userStudioId)
          if (remoteStudio) {
            this.detectedRemoteStudio = remoteStudio
            this.showStudioChangeDialog = true
          }
        }
      }, 1000)

      try {
        if (!this.selectedStudio) await api.getUserStudio()
      } catch (e) {
        this.showStudioSelection = true
      }
    },

    handleAuthenticationError(error) {
      const excludedPaths = ["/forgot", "/datenschutz", "/impressum", "/login", "/contract", "/shop", "/register", "/wheel", "/referral", "/r/"]
      const isExcluded = excludedPaths.some((path) => location.pathname.startsWith(path))

      if (!isExcluded && !error.message.includes("aborted")) {
        this.signOut()
      }
    },

    async login(data) {
      localStorage.setItem("token", data.token)
      await this.handleAuthenticationSuccess(data.token)
      this.clearCustomer()
      this.selectEmployee(null)
      // Handle redirects after login
      if (this.$route.query.redirect) {
        this.$router.push("/" + this.$route.query.redirect.split("%2F").join("/"))
      } else if (this.$route.query.forward) {
        this.$router.push("/" + this.$route.query.forward)
      } else {
        this.$router.push("/")
      }
    },

    signOut() {
      socketService.disconnect()
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      localStorage.removeItem("userRights")
      this.isAuthenticated = false

      const redirectPath = location.pathname.includes("/bewerten") ? `/login?redirect=${location.pathname.replace("/", "")}` : "/login"
      this.$router.push(redirectPath)
    },

    // --- Data Fetching ---
    async fetchNotifications() {
      this.notifications = await api.fetchNotifications()
    },

    async checkVersion() {
      try {
        const { version } = await api.getVersion()
        const localVersion = localStorage.getItem("version")

        // Prüfen, ob eine lokale Version existiert
        if (localVersion === null) {
          // 1. Fall: Erster Besuch
          // Es gibt keine lokale Version, also setze sie einfach, ohne neu zu laden.
          localStorage.setItem("version", version.toString())
        } else if (localVersion !== version.toString()) {
          // 2. Fall: Ein Update ist verfügbar
          // Eine alte Version ist vorhanden und sie unterscheidet sich von der neuen.
          // Setze die neue Version UND lade die Seite neu.
          localStorage.setItem("version", version.toString())
          location.reload()
        }
        // 3. Fall: (localVersion === version.toString()) -> nichts tun, alles ist aktuell.
      } catch (e) {
        console.error("Failed to check version:", e)
      }
    },

    // --- UI & Event Handling ---

    handleOffline() {
      this.isOffline = true
      this.snackbarText = "Internetverbindung unterbrochen"
      this.snackbarColor = "red"
    },

    handleOnline() {
      this.isOffline = false
      this.snackbarText = "Wieder online"
      this.snackbarColor = "green"
      // Hide snackbar after a delay
      setTimeout(() => (this.isOffline = false), 3000)
    },

    updateThemeColors() {
      const themeColors = {}
      Object.keys(this.$vuetify.theme.themes.light).forEach((color) => {
        themeColors[`--v-${color}`] = this.$vuetify.theme.themes.light[color]
      })
      this.cssProps = themeColors
    },

    handleNativeHeaderColor(route) {
      if (window.flutter_inappwebview) {
        setTimeout(() => {
          let color = "rgb(5,5,5)"
          const path = route.matched[0]?.path
          if (path?.includes("nutrition")) color = "rgb(0,150,63)"
          else if (path?.includes("dashboard")) color = "rgb(5,5,5)"
          else if (path?.includes("user") || path?.includes("workout")) color = "rgb(5,5,5)"
          window.flutter_inappwebview.callHandler("colorHandler", color)
        }, 50) // Delay to ensure route is fully resolved
      }
    },

    toggleNavVisibilityForDialogs(isShowing) {
      const isDashboard = this.$route.matched[0]?.name?.includes("dashboard")
      if (!isDashboard) {
        this.setNavigationbarVisibility(!isShowing)
      }
    },

    // --- Notifications ---
    async notificationHandler(notification) {
      this.notificationBell = false
      await api.readNotification(notification._id)
      if (notification.link) {
        this.$router.push(notification.link)
      }
      this.fetchNotifications() // Refresh list
    },

    markAllNotificationsAsRead() {
      api.markAllNotificationsAsRead().then(() => {
        this.fetchNotifications()
      })
    },

    // --- Push Notifications ---
    acceptPush() {
      this.showPushInit = false
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("initPush")
      }
    },

    declinePush() {
      localStorage.setItem("initPushCooldown", new Date().toISOString())
      this.showPushInit = false
    },

    async repairPush() {
      this.isRepairing = true
      try {
        if (window.flutter_inappwebview) {
          // 1. Flutter bitten, alles neu zu generieren
          const result = await window.flutter_inappwebview.callHandler("repairPushToken")

          if (result.success && result.token) {
            // 2. LocalStorage updaten
            localStorage.setItem("pushToken", result.token)

            // 3. An dein Backend senden (deine existierende API Route nutzen)
            await api.updatePushToken({
              pushToken: result.token,
              deviceInfo: result.deviceInfo,
            })

            this.$toast.success("Verbindung repariert!")
          } else {
            this.$toast.error("Fehler beim Abrufen des Tokens.")
          }
        }
      } catch (e) {
        console.error(e)
        this.$toast.error("Reparatur fehlgeschlagen.")
      } finally {
        this.isRepairing = false
      }
    },

    initPush() {
      const pushToken = localStorage.getItem("pushToken")
      const deviceInfo = localStorage.getItem("deviceInfo")
      if (pushToken) {
        api.updatePushToken({ pushToken, deviceInfo })
      }
    },

    // --- Popups & Modals ---
    savedConsent() {
      this.consentPopup = false
    },

    savedNonDisclosureAgreement() {
      this.nonDisclosureAgreementPopup = false
    },

    checkPopup() {
      if (this.isPopupDisabled) return
      this.$refs.popup?.fetchAndShowPopups()
    },

    studioPicked() {
      this.showStudioSelection = false
      // Force re-render of navigation or other studio-dependent components
      const currentNav = this.selectedNavigation

      this.setSelectedNavigation(null)
      this.setSelectedNavigation(currentNav)

      sessionStorage.removeItem("homeCourseData")
      sessionStorage.removeItem("homeNewsData")
      this.$router.push(`/redirect/${this.$route.name}`)
    },

    changeStudioSelectionVisibility(visible) {
      this.showStudioSelection = visible
    },
  },
}
</script>

<style lang="scss">
/* Optional: Falls du das auch für Cards und Sheets willst */

.studio-change-dialog {
  box-shadow: none !important;
  overflow: visible !important;
}

.glass-card {
  background: rgba(30, 30, 30, 0.85) !important; /* Dark Glass */
  backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4) !important;
}

.new-studio-badge {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 12px 24px;
  border-radius: 16px;
  color: white;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: transform 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    transform: scale(1.02);
  }
}

/* Pulse Animation für das Icon */
.sync-icon-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00993f, #006e2e);
  border-radius: 50%;
  box-shadow: 0 10px 20px rgba(0, 153, 63, 0.3);
  z-index: 2;
}

.sync-icon {
  animation: spin 3s linear infinite;
}

.pulse-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #00993f;
  animation: pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
  z-index: 1;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.9);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

/* Globale Styles für das Menü (App.vue Style Block) */
.notification-menu-glass {
  background: rgba(30, 30, 30, 0.85) !important;
  backdrop-filter: blur(20px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 16px !important;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5) !important;
  overflow: hidden; /* Wichtig für Border-Radius */
}

/* Hover Effekt für den Avatar in der Navbar */
.icon-hover-effect {
  transition: all 0.2s ease;
}
.icon-hover-effect:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}
// Scoped styles remain the same as the original file
// General Styles
.app-container-card.chat-full-bleed {
  min-height: unset !important;
  background-color: #121212 !important; /* Passt zum Dark Mode */
}
.forceMarginTop {
  margin-top: 90px !important;
}
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
::v-deep *:not(.material-icons, .fa) {
  font-family: "Saira", sans-serif !important;
}

::v-deep .v-application {
  font-family: "Saira", sans-serif !important;
}

/* Stelle sicher, dass auch spezifische Vuetify-Klassen abgedeckt sind */
.v-application .headline,
.v-application .title,
.v-application .body-1,
.v-application .body-2 {
  font-family: "Saira", sans-serif !important;
}

.fullHeight {
  height: 100vh;
}
.smallMarginTop {
  margin-top: 80px !important;
}
.removeMarginTop {
  margin-top: 0 !important;
}
.loginCard {
  border-radius: 0 !important;
}
.app-container-card {
  min-height: 60vh;
  background-color: unset !important;
}

// App Bar & Header
.app-bar::v-deep .v-toolbar__content {
  display: flex;
  align-items: center;
  height: 100% !important;
}
.navbarTitle {
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: bold;
}
.Home__greeting {
  display: block;
  position: relative;
  &-subtitle {
    color: black !important;
    letter-spacing: 1px;
    font-weight: bold;
    padding-bottom: 0px;
  }
  &-title {
    letter-spacing: 1px;
    padding-top: 0px;
    display: block;
    font-weight: bold;
    &-training {
      color: orange;
    }
  }
}

.neumorphic-button {
  border-radius: 12px !important; /* Etwas weichere Kanten */
  background: #eef0f4 !important; /* Hintergrundfarbe des Buttons = Hintergrundfarbe der Seite */
  color: #5b6271 !important; /* Weichere Textfarbe */
  font-weight: 600 !important;
  letter-spacing: 0.5px;

  /* Der magische 3D-Schatten */
  box-shadow:
    /* Dunkler Schatten unten rechts */ 4px 4px 8px #d1d5db, /* Heller Lichteffekt oben links */ -4px -4px 8px #ffffff !important;

  transition: all 0.15s ease-in-out !important;
}

.neumorphic-button:hover {
  color: #313131 !important;
  box-shadow: 2px 2px 5px #d1d5db, -2px -2px 5px #ffffff !important;
}

/* Der "hineingedrückte" Effekt beim Klick */
.neumorphic-button:active {
  color: #313131 !important;
  box-shadow:
    /* Die Schatten werden nach innen gekehrt */ inset 4px 4px 8px #d1d5db, inset -4px -4px 8px #ffffff !important;
}
</style>
